import React from "react";

import queryString from "query-string";

import MainBodyTabs from "../common/MainBodyTabs";
import MainButton from "../common/MainButton";
import MainTitle from "../common/MainTitle";
import Routes from "./Routes";

import lbl from "../../data/Labels.json";

const CreditorProfile = (props) => {
  const { creditorName } = queryString.parse(props.location.search);

  const tabs = [
    {
      name: "اطلاعات عمومی",
      path: "",
      urlParams: `creditorName=${creditorName}`,
    },
    {
      name: "مالی",
      path: "finance",
      urlParams: `creditorName=${creditorName}`,
    },
  ];

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainButton title={lbl.PrevPage} type={"back"} />
          <MainTitle title={creditorName} />
        </div>
      </div>
      <div className="main-content-body">
        <MainBodyTabs tabs={tabs} {...props} />
        <Routes {...props} />
      </div>
    </div>
  );
};

export default CreditorProfile;
